// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "" + {"897":"styles/app","981":"styles/admin"}[chunkId] + ".css";
};